function EmptyLayout({children}) {
	return (
		<div className="wrapper">
			{children}
		</div>
	);
}

export default EmptyLayout;